import React from "react";

function Stars({ value }) {
  const rounded = Math.round(value);
  return (
    <div className="flex text-yellow-500 text-sm">
      {[1,2,3,4,5].map(i => (
        <span key={i}>
          {i <= rounded ? "★" : "☆"}
        </span>
      ))}
    </div>
  );
}
export default Stars;